import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, iif, interval } from 'rxjs';
import { switchMap, takeUntil, filter, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PrinterService {

  private _lastState: string = '';

  constructor(private http: HttpClient) {

  }

  // private _printerFound = this.getStateUntilConnected().pipe(filter(val => val === 'connected'));
  getStateUntilConnected(): Observable<string> {
    const source = interval(10000);
    const printerState = source.pipe(
      switchMap(() => iif(
        () => this._lastState === 'connected',
        this.getState(),
        this.findPrinter())
      ),
      tap((data) => {this._lastState = data; })
    );
    // const _printerFound = printerState.pipe(filter(val => val === 'connected'));

    // return printerState.pipe(
    //   takeUntil(_printerFound)
    // )
    return printerState;
  }

  getState(): Observable<string> {
    return this.http.get<string>('/api/printer/state');
  }


  findPrinter(): Observable<string> {
    return this.http.post<string>('/api/printer/find', {});
  }
}
